import type { ValueOf } from '../util/typeUtils';

export const DIVISION_COMMANDS = {
    activateFooterTemplate: 'activateFooterTemplate',
    activateHeaderTemplate: 'activateHeaderTemplate',
    addBucket: 'addBucket',
    addLeader: 'addLeader',
    changeKind: 'changeKind',
    create: 'create',
    deactivate: 'deactivate',
    deactivateFooterTemplate: 'deactivateFooterTemplate',
    deactivateHeaderTemplate: 'deactivateHeaderTemplate',
    removeBucket: 'removeBucket',
    removeLeader: 'removeLeader',
    removeMetaPhoneNumberId: 'removeMetaPhoneNumberId',
    rename: 'rename',
    setMetaPhoneNumberId: 'setMetaPhoneNumberId',
} as const;

export type DIVISION_COMMAND = ValueOf<typeof DIVISION_COMMANDS>;
